package info.rezident.app.data.auth

/**
 * Utility object for handling Firebase authentication errors and providing
 * user-friendly Romanian error messages.
 */
object AuthErrorHandler {

    /**
     * Converts a Firebase authentication error to a user-friendly Romanian message.
     *
     * @param throwable The error thrown by Firebase authentication
     * @return A user-friendly Romanian error message
     */
    fun getErrorMessage(throwable: Throwable): String {
        val errorMessage = throwable.message ?: ""

        return when {
            // Email/Password authentication errors
            errorMessage.contains("auth/user-not-found") ->
                "Nu există niciun cont asociat cu această adresă de e-mail."

            errorMessage.contains("auth/wrong-password") ->
                "E-mail-ul sau parola introdusă este incorectă."

            errorMessage.contains("auth/invalid-email") ->
                "E-mail-ul sau parola introdusă este incorectă."

            errorMessage.contains("auth/weak-password") ->
                "Parola este prea slabă. Trebuie să conțină cel puțin 8 caractere."

            errorMessage.contains("auth/email-already-in-use") ->
                "Această adresă de e-mail este deja folosită."

            errorMessage.contains("auth/too-many-requests") ->
                "Prea multe încercări eșuate. Încearcă din nou mai târziu."

            errorMessage.contains("auth/user-disabled") ->
                "Contul a fost dezactivat. Contactează-ne pentru asistență."

            errorMessage.contains("auth/invalid-credential") ->
                "E-mail-ul sau parola introdusă este invalidă"

            errorMessage.contains("auth/account-exists-with-different-credential") ->
                "Un cont cu această adresă de e-mail există deja, dar cu o metodă de autentificare diferită."

            errorMessage.contains("auth/network-request-failed") ->
                "Eroare de conexiune la internet. Verifică conexiunea și încearcă din nou."

            errorMessage.contains("auth/popup-closed-by-user") ->
                "Fereastra de autentificare a fost închisă. Încearcă din nou."

            errorMessage.contains("auth/popup-blocked") ->
                "Fereastra de autentificare a fost blocată de browser. Permite popup-urile și încearcă din nou."

            errorMessage.contains("auth/cancelled-popup-request") ->
                "Cererea de autentificare a fost anulată."

            errorMessage.contains("auth/popup-closed-by-user") ->
                "Fereastra de autentificare a fost închisă înainte de finalizare."

            // Google Sign-In specific errors
            errorMessage.contains("popup", ignoreCase = true) ->
                "Eroare la deschiderea ferestrei de autentificare. Încearcă din nou."

            errorMessage.contains("blocked", ignoreCase = true) ->
                "Fereastra de autentificare a fost blocată. Permite popup-urile și încearcă din nou."

            // Generic error messages for common patterns
            errorMessage.contains("timeout", ignoreCase = true) ->
                "Cererea a expirat. Verifică conexiunea și încearcă din nou."

            errorMessage.contains("network", ignoreCase = true) ->
                "Eroare de conexiune la rețea. Verifică conexiunea la internet."

            errorMessage.contains("server", ignoreCase = true) ->
                "Eroare de server. Încearcă din nou în câteva momente."

            // Default fallback message
            else -> "Ceva nu a mers bine. Încearcă din nou."
        }
    }
} 